import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import Layout from '../Layout/Layout';
import { setCurrentEvent } from '../redux/actions/event';

import "./adminmultievent.scss";

function AdminMultiEvent ({events, currentEvent, ...props}) {

	if(currentEvent) {
		return <Redirect to="/dashboard" />
	}

	function selectEvent (event) {
		if(currentEvent?.name !== event.name) {
			props.dispatch(setCurrentEvent(event.id))
		}
	}

	return (
		<Layout page="multievent-page">
			<div className="multievent container-fluid">
				<h1 className="mb-3">Your Events</h1>
				<h4 className="mb-5">Please select the event you will be working on today</h4>

				<div className="event-list">
					{
						events.map(event => {
							return (
								<div
									key={`event_${event.id}`}
									className="event"
									onClick={() => selectEvent(event)}
								>
									<div className="preview" style={{backgroundImage: `url("${event.logo_image.download_url}")`}}></div>
									<h4 className="title">{event.name}</h4>
								</div>
							)
						})
					}
				</div>
			</div>
		</Layout>
	)
}

const mapStateToProps = (state) => ({
	currentEvent: state.event.current,
	events: state.event.list
});

export default connect(mapStateToProps)(AdminMultiEvent);